import React, { useState, useEffect } from "react";
import { Box, Button, Select, MenuItem } from "@mui/material";
import { Route, Routes } from 'react-router-dom'
import { useNavigate } from "react-router";
import {useDispatch, useSelector} from "react-redux"
import { setUserInfo } from "../../redux/slice/user";
import api from "../../API";
import GroupIcon from '@mui/icons-material/Group';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import RuleIcon from '@mui/icons-material/Rule';
import TranslateIcon from '@mui/icons-material/Translate';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { SearchBackDrop } from "../component/common/SearchBackDrop";

interface UseCheckCntType {
  t_cnt: number;
  c_cnt: number;
  f_cnt: number;
}

const initailData_use_check: UseCheckCntType = {
  t_cnt: 0,
  c_cnt: 0,
  f_cnt: 0
};

const VieWorkerMenuPage = (props:any) => {

  const dispatch = useDispatch();

  const nav = useNavigate();

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  let manager_role = auth.user.roles.some((obj:any) => ['VIE','VIE_PRC','VIE_MANAGER'].includes(obj.role));

  // const [isp_mode , setIsp_mode] = useState<boolean>(manager_role);

  const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)
 
  const getAuth = async () => {
    if(!email){ nav('/') }
    api.get('/@me',{params:{email:email}})
    .then((resp:any) => {dispatch(setUserInfo(resp.data)); console.log('/@me',resp.data) })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }


  useEffect(() => {
    getAuth()
  },[])

  return (
    <Box>
      <Box sx={{ backgroundColor: "#fff", height: "100%", maxWidth: "100%" }}>
        <Box sx={{textAlign: "center", paddingTop:"20px"}}><img style={{width:"120px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/vi_flag.jpg'} /></Box>
        <Box sx={{fontSize:"60px", textAlign: "center", padding: "5px 20px 20px 20px"}}>Vietnam Page</Box>
        <Box sx={{display:"flex", justifyContent: "center", marginTop:"100px"}}>
          
          <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "50px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#61b655", color: "#fff", "&:hover": { background: "#51a7da",color: "#fff"}}} variant="contained" onClick={()=> nav('create')}>
            신규
          <ModeEditIcon sx={{fontSize:"100px", marginLeft:"10px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
          </Button>
          
          <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "50px", marginRight:"px", marginLeft:"50px", fontWeight: 600, backgroundColor: "#5e69c4", color: "#fff", "&:hover": { background: "#51a7da",color: "#fff"}}} variant="contained" onClick={()=> nav('ref')}>
            정제 
          <RuleIcon sx={{fontSize:"100px", marginLeft:"10px", color:"#fff",justifyContent: "center" }}></RuleIcon>
          </Button>

          <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "50px", marginRight:"px", marginLeft:"50px", fontWeight: 600, backgroundColor: "#b05ec4", color: "#fff", "&:hover": { background: "#51a7da",color: "#fff"}}} variant="contained" onClick={()=> nav('prc')}>
            가공 
          <EditNoteIcon sx={{fontSize:"100px", marginLeft:"10px", color:"#fff",justifyContent: "center" }}></EditNoteIcon>
          </Button>

          <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "50px", marginRight:"px", marginLeft:"50px", fontWeight: 600, backgroundColor: "#daba51", color: "#fff", "&:hover": { background: "#51a7da",color: "#fff"}}} variant="contained" onClick={()=> nav('isp')}>
            검수 
          <FactCheckIcon sx={{fontSize:"100px", marginLeft:"10px", color:"#fff",justifyContent: "center" }}></FactCheckIcon>
          </Button>
          {/* <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "50px", marginRight:"20px", marginLeft:"50px", fontWeight: 600, backgroundColor: "#df8e43", color: "#fff", "&:hover": { background: "#51a7da",color: "#fff"}}} variant="contained" >
            소음
          </Button> */}
        </Box>
        

        {/* <Box sx={{display:"flex" , justifyContent: "center", marginTop:"50px"}}>
          <Button sx={{width: "230px", fontSize: "24px", marginLeft:"24px", fontWeight: 600, backgroundColor: sampleListPage? "#404ec7" : "#3fb92e", color: "#fff", "&:hover": { background: "#51a7da",color: "#fff"}}} variant="contained" onClick={()=>setSampleListPage(!sampleListPage)}>{sampleListPage? <>제출현황 페이지</>: <>업로드 페이지</>}</Button>
          <Button sx={{width: "230px", fontSize: "24px", marginRight:"20px", marginLeft:"50px", fontWeight: 600, backgroundColor: sampleListPage? "#404ec7" : "#3fb92e", color: "#fff", "&:hover": { background: "#51a7da",color: "#fff"}}} variant="contained" onClick={()=>setSampleListPage(!sampleListPage)}>{sampleListPage? <>업로드 페이지</>: <>제출현황 페이지</>}</Button>
        </Box> */}


        {/* <Box sx={{display: 'none', justifyContent: "center", padding:"72px"}}>
            {sampleListPage ?
              <SampleListPage samples={samples} />
            :
              (user_state === 'sample_upload' ?
                // 샘플 파일 업로드
                <SampleUploadPage sampleUploadList={sampleUploadList} />  
                :
                // 문서 제출
                <ConfirmListPage samples={samples} sampleUploadList={sampleUploadList}  />
              )
            }

        </Box> */}
      </Box>

      {/* Task 단위 화면 */}
      {/* <Box><textarea spellCheck="false" value={"ប្រើពុម្ពអក្សរខ្មែរ"} style={{width:"430px",minHeight:"40px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box> */}
      {/* <Box><textarea spellCheck="false" value={"ប្រើពុម្ពអក្សរខ្មែរ"} style={{width:"430px",minHeight:"40px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Khmer OS, serif"}}  /></Box> */}
      {/* <Box><textarea spellCheck="false" value={"ប្រើពុម្ពអក្សរខ្មែរ"} style={{width:"430px",minHeight:"40px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "'Noto Sans Khmer', sans-serif"}}  /></Box> */}
      {/* Task 단위 화면 */}
    </Box>
  );
};

export default VieWorkerMenuPage;
